// Line types
export const ARTICLE_LINE = 100
export const PAYMENT_LINE = 200
export const PAYMENT_ROUNDED_LINE = 210
export const GLOBAL_LINE = 300
export const CONFIGURATION_LINE = 400
export const SUBTOTAL_LINE = 500
export const RECEIPT_INFO_LINE = 510
export const DISCOUNT_LINE = 700

// Button types
export const BUTTON_ARTICLE = 1
export const BUTTON_FUNCTION = 2
export const BUTTON_KIOSK = 3
export const BUTTON_OTHER = 4

//DISCOUNT types
export const DISCOUNT_AMOUNT = 100
export const DISCOUNT_PERCENTAGE = 200

// Deivce types
export const DEVICE_PRINTER = 100
export const DEVICE_BLACKBOX = 200
export const DEVICE_BARIX = 300
export const DEVICE_DRAWER = 400
export const DEVICE_SCALE = 700

// PaymentStatus
export const PAYMENTSTATUS_SUCCESS = 100
export const PAYMENTSTATUS_BUSY = 200
export const PAYMENTSTATUS_FAILED = 300

// Receipt button types
export const RECEIPTBUTTON_STOP_RECEIPT = 100
export const RECEIPTBUTTON_RETOUR = 200
export const RECEIPTBUTTON_KIOSK_STOP_RECEIPT = 300;
export const RECEIPTBUTTON_KIOSK_CONFIRM_ORDER = 400;
export const RECEIPTBUTTON_EMPTY_RECEIPT = 500;
export const RECEIPTBUTTON_PROCESS_RECEIPT = 600;

// PosTypes
export const POSTYPE_NORMAL = 100
export const POSTYPE_ORDERKIOSK = 200
export const POSTYPE_CHARGINGKIOSK = 300
export const POSTYPE_SALESKIOSK = 400
export const POSTYPE_PRODUCTIONKIOSK = 500
export const POSTYPE_TICKETSCANNER = 600
export const POSTYPE_WEBSHOP = 999

// Invoice print types
export const INVOICE_NONE = 0
export const INVOICE_PRINT = 1
export const INVOICE_EMAIL = 2
export const INVOICE_EMAIL_PRINT = 3

// DisplayMode
export const DISPLAYMODE_CLASSIC = 100
export const DISPLAYMODE_FREEFORMAT = 200

//TicketType provider
export const DEFAULT_TICKETTYPE_PROVIDER = "Sintrum.Pos.Providers.Ticket.DefaultTicketProvider"



// WEBPACK FOOTER //
// src/constants/Types.js